
class Rect {
    self: HTMLElement;
    height: number;
    width: number;
    aspectRatio: number;
    constructor(self: HTMLElement, height: number, width: number) {
        this.self = self;
        this.height = height;
        this.width = width;
        this.aspectRatio = this.width / this.height;
    }
}

class VideoSizer {

    image: Rect;
    container: Rect;
    overlay: HTMLElement;

    constructor(image: HTMLImageElement, container: HTMLElement, overlay: HTMLElement) {
        this.image = new Rect(image, image.naturalHeight, image.naturalWidth);
        this.container = new Rect(container, container.clientHeight, container.clientWidth);
        this.overlay = overlay;
    }

    setSize() {
        if (this.image.aspectRatio > this.container.aspectRatio) {
            this._setMaxWidth();
        } else {
            this._setMaxHeight();
        }
    }

    _setMaxHeight() {
        const targetHeight = Math.floor(this.container.height);
        const targetWidth = Math.floor(targetHeight * this.image.aspectRatio);
        this._setElementSize(this.image.self, targetWidth, targetHeight);
        this._setElementSize(this.overlay, targetWidth, targetHeight);
        this._setSVGViewBoxSize(this.overlay, targetWidth, targetHeight);
    }
    _setMaxWidth() {
        const targetWidth = Math.floor(this.container.width);
        const targetHeight = Math.floor(targetWidth / this.image.aspectRatio);
        this._setElementSize(this.image.self, targetWidth, targetHeight);
        this._setElementSize(this.overlay, targetWidth, targetHeight);
        this._setSVGViewBoxSize(this.overlay, targetWidth, targetHeight);
    }

    _setElementSize(el: HTMLElement, width: number, height: number) {
        el.style.width = width + 'px';
        el.style.height = height + 'px';
    }
    _setSVGViewBoxSize(el: HTMLElement, width: number, height: number) {
        el.setAttribute('viewBox', '0 0 ' + width + ' ' + height + '');
    }
}

export { VideoSizer };
